import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';

import {
    withRouter,
    NavLink,
} from 'react-router-dom';

import {
    reverseRoute,
} from '../../../public/utils/common';

import { List } from '../../../public/components/View';
import styles from './styles.scss';

import {
    DropdownMenu,
    DropdownGroup,
} from '../../../public/components/Action';

import {
    pageTitles,
    pathNames,
} from '../../constants';
import { getTechnicalAnalysisURL, getMultiChartURL } from '../../rest';

const propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.string,
    ),
    className: PropTypes.string,
    ticker: PropTypes.string,
};

const defaultProps = {
    className: '',
    ticker: undefined,
    links: [],
};

@withRouter
@CSSModules(styles, { allowMultiple: true })
export default class NavMenu extends React.PureComponent {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    constructor(props) {
        super(props);

        const overflowMenuLinks = [];

        this.state = {
            navLinks: props.links,
            overflowMenuLinks,
            overflow: false,
        };
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentDidMount() {
        this.computeSize();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            navLinks: nextProps.links,
        }, () => {
            this.computeSize();
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    getTechnicalAnalysisDropdown = () => (
        <DropdownMenu
            dropdownClassName={styles['technical-dropdown-container']}
            iconName=""
            title="Technical Analysis"
        >
            <DropdownGroup>
                <a
                    href={getTechnicalAnalysisURL()}
                    className={styles.button}
                    target="_blank"
                >
                    Single Chart
                </a>
                <a
                    href={getMultiChartURL()}
                    className={styles.button}
                    target="_blank"
                >
                    Multi Chart
                </a>
            </DropdownGroup >
        </DropdownMenu >
    )

    getNavItem = (key, item, className) => {
        const {
            ticker,
        } = this.props;

        const { overflow } = this.state;

        const params = {
            ticker,
        };

        if (key === 'technicalAnalysis') {
            if (overflow === false) {
                return (
                    this.getTechnicalAnalysisDropdown()
                );
            }
        }

        if (pathNames[item]) {
            return (
                <NavLink
                    key={key}
                    activeClassName={styles.active}
                    to={reverseRoute(pathNames[item], params)}
                    className={className}
                    exact
                >
                    {pageTitles[item]}
                </NavLink>
            );
        }

        return null;
    };

    getNavbarItem = (key, item) => (
        this.getNavItem(key, item, styles['menu-item'])
    );

    getOverflowMenuItem = (key, item) => (
        this.getNavItem(key, item, styles['overflow-menu-item'])
    );

    computeSize = () => {
        const menu = this.menu;
        const {
            navLinks,
        } = this.state;

        const overflowMenuLinks = [];

        if (menu) {
            const cr = menu.getBoundingClientRect();

            const links = menu.getElementsByTagName('a');
            const overflow = menu.querySelector('#overflow');

            const linkWidths = [];
            let totalWidth = 0;

            for (let i = 0; i < links.length; i += 1) {
                links[i].style.display = 'inline-flex';
                const width = links[i].getBoundingClientRect().width;
                linkWidths.push(width);
                totalWidth += width;
            }

            totalWidth += 150;
            linkWidths.push(150);

            if (menu.scrollWidth > Math.ceil(cr.width)) {
                this.setState({
                    overflow: true,
                });
                totalWidth += overflow.getBoundingClientRect().width;

                linkWidths.reverse();

                let lastVisibleLinkIndex = links.length - 1;
                while (totalWidth > cr.width) {
                    overflowMenuLinks.unshift(navLinks[lastVisibleLinkIndex]);

                    totalWidth -= linkWidths[0];
                    linkWidths.shift();

                    links[lastVisibleLinkIndex].style.display = 'none';
                    overflow.style.display = 'inline-flex';
                    lastVisibleLinkIndex -= 1;

                    if (lastVisibleLinkIndex < 0) {
                        break;
                    }
                }
            } else {
                this.setState({
                    overflow: false,
                });
                overflow.style.display = 'none';

                for (let i = 0; i < links.length; i += 1) {
                    links[i].style.display = 'inline-flex';
                }
            }
        }

        this.setState({
            overflowMenuLinks,
        });
    };
    keyExtractor = d => d;

    handleWindowResize = () => {
        this.computeSize();
    };

    render() {
        const {
            className,
        } = this.props;

        const {
            navLinks,
            overflowMenuLinks,
            overflow,
        } = this.state;

        return (
            <div
                ref={(el) => {
                    this.menu = el;
                }}
                styleName="nav-menu"
                className={className}
            >
                <List
                    data={navLinks}
                    modifier={this.getNavbarItem}
                    keyExtractor={this.keyExtractor}
                />

                <DropdownMenu
                    id="overflow"
                    iconName="ion-android-more-horizontal"
                    styleName="overflow-menu"
                    hideDropdownIcon
                    dropdownClassName={styles['navbar-overflow-dropdown-container']}
                >
                    <List
                        data={overflowMenuLinks}
                        modifier={this.getOverflowMenuItem}
                        keyExtractor={this.keyExtractor}
                    />

                    {overflow === true && this.getTechnicalAnalysisDropdown()}
                </DropdownMenu>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/Navbar/NavMenu.js